/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';

import Resource from 'solis/data/resource';
import Settings from 'solis/data/settings';
import ColonyDraft from 'solis/data/account/colony.draft';


export default class Account extends Entity
{
  static children = [ 'boardViews', 'colonyDrafts', 'currentColonyViews', 'originSectorViews' ];


  loadSettings (settings)
  {
    this.getSettings().load(settings.cass);
  }


  loadBoardView (cass)
  {
    return this.getBoardViews().load(cass.id, cass);
  }


  loadColonyDraft (cass)
  {
    return this.getColonyDrafts().load(cass.id, cass);
  }


  loadCurrentColonyView (cass)
  {
    return this.getCurrentColonyViews().load(cass.colony, cass);
  }


  loadOriginSectorView (cass)
  {
    return this.getOriginSectorViews().load(cass.sector, cass);
  }


  unloadBoardView (cass)
  {
    this.getBoardViews().unload(cass.id);
  }


  unloadColonyDraft (cass)
  {
    this.getColonyDrafts().unload(cass.id);
  }


  unloadCurrentColonyView (cass)
  {
    this.getCurrentColonyViews().unload(cass.colony);
  }


  unloadOriginSectorView (cass)
  {
    this.getOriginSectorViews().unload(cass.sector);
  }


  createBoardView (board)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.user = this.cass.id;

    cass.id = board.cass.id;
    cass.createDate = board.cass.createDate;
    cass.destroyDate = board.cass.destroyDate;

    cass.colonies = [];

    return this.loadBoardView(cass);
  }


  createColonyDraft (id)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.user = this.cass.id;

    cass.id = id;

    return this.loadColonyDraft(cass);
  }


  createCurrentColonyView (colony)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.user = this.cass.id;

    cass.colony = colony;

    return this.loadCurrentColonyView(cass);
  }


  createOriginSectorView (colony, sector)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.user = this.cass.id;

    cass.colony = colony;
    cass.sector = sector;

    return this.loadOriginSectorView(cass);
  }


  getSettings ()
  {
    return new Settings(this.cursor.child('settings'));
  }


  getGravityResource ()
  {
    return new Resource(this.cass.gravityResource, this.getSettings().getGravityResource());
  }


  getRetryResource ()
  {
    return new Resource(this.cass.retryResource, this.getSettings().getRetryResource());
  }


  getBoardView (id)
  {
    return this.getBoardViews().at(id);
  }


  getBoardViews ()
  {
    return new Collection(Entity, this.cursor.child('boardViews'));
  }


  getColonyDraft (id)
  {
    return this.getColonyDrafts().at(id);
  }


  getColonyDrafts ()
  {
    return new Collection(ColonyDraft, this.cursor.child('colonyDrafts'));
  }


  // QQ remove once we have a corresponding logic.
  getAttachedColonyIDs ()
  {
    const ids = new Set();

    for (const view of this.getBoardViews().values())
    {
      for (const id of view.cass.colonies)
      {
        ids.add(id);
      }
    }

    return ids;
  }


  getCurrentColonyViews ()
  {
    return new Collection(Entity, this.cursor.child('currentColonyViews'));
  }


  getOriginSectorViews ()
  {
    return new Collection(Entity, this.cursor.child('originSectorViews'));
  }


};
